import React from 'react';

import StrokeIcon, { StrokeIconProps } from './StrokeIcon';

export default function ArrowUpRightIcon(props: StrokeIconProps): JSX.Element {
  return (
    <StrokeIcon {...props}>
      <path d="M7 7h10v10" />
      <path d="M7 17 17 7" />
    </StrokeIcon>
  );
}
